import { RelodeApiError } from "core/src/modules";
import * as React from "react";

export class ErrorActionType {
    applicationError: RelodeApiError;
}

export class SuccessAction {
    constructor(public message?: React.ReactNode) {}
}

// deprecated
export interface SuccessActionType {
    successMessage?: React.ReactNode;
}
